import { CheckCircle2, ShieldCheck, Clock, Leaf } from "lucide-react";

const POINTS = [
  {
    icon: ShieldCheck,
    title: "Assuré & déclaré",
    desc: "Entreprise déclarée, intervenants formés et matériel professionnel.",
  },
  {
    icon: Clock,
    title: "Ponctualité",
    desc: "Plannings respectés, communication claire avec syndics et gérants.",
  },
  {
    icon: Leaf,
    title: "Approche raisonnée",
    desc: "Produits adaptés et gestion responsable des déchets verts.",
  },
  {
    icon: CheckCircle2,
    title: "Devis gratuit",
    desc: "Réponse rapide et tarification transparente, sans engagement.",
  },
];

export default function About() {
  return (
    <section
      id="apropos"
      data-testid="about-section"
      className="relative py-24 md:py-32 bg-[#FDFCFB]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-2 gap-16 lg:gap-24 items-start">
        <div>
          <div className="text-xs uppercase tracking-widest font-semibold text-[#5C635A]">
            — À propos
          </div>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tighter text-[#1E2320] leading-tight">
            Une entreprise locale,
            <br />
            <span className="text-[#1A4331]">au service de la Provence.</span>
          </h2>
          <p className="mt-6 text-base sm:text-lg text-[#5C635A] leading-relaxed">
            Basée à <strong className="text-[#1E2320]">Bouc-Bel-Air</strong>, FBSERVICES intervient sur
            l'ensemble du bassin aixois et marseillais. Nous accompagnons aussi bien les
            syndics de copropriété, les entreprises que les particuliers, avec la même
            exigence et le même soin du détail.
          </p>
          <p className="mt-4 text-base text-[#5C635A] leading-relaxed">
            Notre force : une équipe polyvalente capable de gérer
            <strong className="text-[#1E2320]"> nettoyage et espaces verts </strong>
            d'une seule main — vous gagnez du temps, de la simplicité et de la qualité.
          </p>

          <div className="mt-10 flex flex-wrap gap-3">
            <a
              href="#contact"
              data-testid="about-cta-contact"
              className="inline-flex items-center rounded-full px-7 py-3.5 text-sm font-medium bg-[#1A4331] text-white hover:bg-[#123022] transition-all duration-300"
            >
              Nous contacter
            </a>
            <a
              href="#services"
              data-testid="about-cta-services"
              className="inline-flex items-center rounded-full px-7 py-3.5 text-sm font-medium bg-white border border-[#E5E7E2] text-[#1E2320] hover:bg-[#F3F4F1] transition-all duration-300"
            >
              Voir nos services
            </a>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 gap-5">
          {POINTS.map((p, i) => {
            const Icon = p.icon;
            return (
              <div
                key={p.title}
                data-testid={`about-point-${i}`}
                className="rounded-2xl bg-white border border-[#E5E7E2] p-6 transition-all hover:shadow-md hover:-translate-y-0.5"
              >
                <div className="grid place-items-center h-11 w-11 rounded-xl bg-[#F3F4F1] text-[#1A4331]">
                  <Icon className="h-5 w-5" />
                </div>
                <h4 className="mt-5 font-display text-lg font-medium text-[#1E2320]">
                  {p.title}
                </h4>
                <p className="mt-2 text-sm text-[#5C635A] leading-relaxed">{p.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
